import { Form } from '@domain-group/suit-theme'
import { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import { useOrderItemForm, UseOrderItemPayload } from '@hooks/useOrderItem'

import type { OrderItemModel } from '@models/types'

interface NotesProps {
 orderItem: OrderItemModel,
 callbacks: {
  updateOrderItem: (payload: HandleCallbackActionParams) => void,
  updateOrderItemFn: UseOrderItemPayload['callbacks']['updateOrderItem'],
 },
}

const Notes = (props: NotesProps) => {
  const { orderItem, callbacks } = props
  const { updateOrderItem, updateOrderItemFn } = callbacks
  const orderItemFormPayload = useOrderItemForm(orderItem)

  const {
    entityState: {
      additional_instructions,
    },
    setEntityState,
  } = orderItemFormPayload

  const updateOrderItemPayload = {
    callbacks: {
      action: updateOrderItemFn,
    },
    entityParams: { additional_instructions },
    toastText: 'Order Item Instructions Updated',
  }

  return (
    <Form.Field direction="column" label="Additional Instructions" marginTop="large">
      <textarea
        value={additional_instructions}
        placeholder="You can include additional instructions for the order..."
        onChange={e => setEntityState({ additional_instructions: e.target.value })}
        onBlur={() => updateOrderItem(updateOrderItemPayload)}
        style={{ height: 80, resize: 'vertical' }}
      />
    </Form.Field>
  )
}

export default Notes
